"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSizeme = require("react-sizeme");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactFiles = _interopRequireDefault(require("react-files"));

var _uiKit = require("@devsta/ui-kit");

var _clientAwsS = require("@devsta/client-aws-s3");

require("../styles/_presenter.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SMALL_THRESHOLD = 345;

var Presenter = /*#__PURE__*/function (_Component) {
  _inherits(Presenter, _Component);

  var _super = _createSuper(Presenter);

  function Presenter() {
    var _this;

    _classCallCheck(this, Presenter);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onSelectImage", function (index) {
      return (/*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(files) {
            var _this$props, onUpdatePresenter, _this$props$video, videoId, organisationId, presenterId, apolloClient, file, imageKey, url;

            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this$props = _this.props, onUpdatePresenter = _this$props.onUpdatePresenter, _this$props$video = _this$props.video, videoId = _this$props$video.videoId, organisationId = _this$props$video.organisationId, presenterId = _this$props.presenter.presenterId, apolloClient = _this$props.apolloClient;

                    if (videoId) {
                      _context.next = 3;
                      break;
                    }

                    return _context.abrupt("return", void 0);

                  case 3:
                    file = files.slice(-1)[0];
                    imageKey = "organisation/".concat(organisationId, "/video/").concat(videoId, "/presenter/").concat(presenterId, "/profileImage");
                    _context.next = 7;
                    return (0, _clientAwsS.uploadFile)({
                      apiClient: apolloClient,
                      bucketKey: imageKey,
                      file: file,
                      organisationId: organisationId
                    });

                  case 7:
                    url = file.preview.url;

                    _this.setState({
                      localPresenterImageUrl: url
                    });

                    return _context.abrupt("return", void onUpdatePresenter('imageKey', index)(imageKey));

                  case 10:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()
      );
    });

    _this.state = {
      localPresenterImageUrl: void 0
    };
    return _this;
  }

  _createClass(Presenter, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          onRemovePresenter = _this$props2.onRemovePresenter,
          onUpdatePresenter = _this$props2.onUpdatePresenter,
          presenter = _this$props2.presenter,
          index = _this$props2.index,
          canUpdateVideo = _this$props2.canUpdateVideo;
      var localPresenterImageUrl = this.state.localPresenterImageUrl;
      return (/*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, canUpdateVideo ? /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
          name: "close",
          size: 15,
          className: "presenter__remove",
          onClick: onRemovePresenter,
          color: "regent"
        }) : null, /*#__PURE__*/_react.default.createElement(_reactSizeme.SizeMe, null, function (_ref2) {
          var size = _ref2.size;
          return (/*#__PURE__*/_react.default.createElement("div", {
              className: (0, _classnames.default)('presenter', {
                'presenter--small': size.width < SMALL_THRESHOLD
              })
            }, /*#__PURE__*/_react.default.createElement(_reactFiles.default, {
              dropActiveClassName: "upload-assets__uploader--active",
              onChange: canUpdateVideo ? _this2.onSelectImage(index) : void 0,
              accepts: ['image/*'],
              clickable: canUpdateVideo
            }, /*#__PURE__*/_react.default.createElement(_uiKit.Image, {
              imageUrl: localPresenterImageUrl || presenter.imageUrl,
              width: "140px",
              height: "140px",
              isEditableImage: canUpdateVideo,
              defaultIconBackground: "raspingSandy",
              defaultImageIcon: "user",
              onClick: Function.prototype,
              backgroundSize: "cover"
            })), /*#__PURE__*/_react.default.createElement("div", {
              className: "presenter__right"
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "presenter__right__block"
            }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
              label: "PRESENTER ".concat(index + 1),
              placeholder: canUpdateVideo ? 'Enter presenter name' : 'Presenter name',
              onChange: onUpdatePresenter('name', index),
              defaultValue: presenter.name,
              small: true,
              disabled: !canUpdateVideo
            })), /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
              label: "TITLE ".concat(index + 1),
              placeholder: "Enter presenter title",
              onChange: onUpdatePresenter('title', index),
              defaultValue: presenter.title,
              small: true,
              disabled: !canUpdateVideo
            })))
          );
        }), /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
          className: "presenter__description",
          label: "DESCRIPTION ".concat(index + 1),
          placeholder: canUpdateVideo ? "Enter description of Presenter ".concat(index + 1) : "Description of Presenter ".concat(index + 1),
          onChange: onUpdatePresenter('description', index),
          defaultValue: presenter.description,
          multiline: true,
          small: true,
          disabled: !canUpdateVideo
        }))
      );
    }
  }]);

  return Presenter;
}(_react.Component);

exports.default = Presenter;